import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faClock, faVideo, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import '../../styles/ScheduleMeeting.css';

const CALENDAR_URL =
    'https://calendar.google.com/calendar/appointments/schedules/AcZssZ3qbLnMjn4KgcVjoZHNhlHnYs2QqLJ5GH6Vg35YbPfpiS3aV1tt_C58uqHZMNmjxF7LKzSuq1pG?gv=true';

const PERKS = [
    { icon: faClock,         text: '30-minute free consultation' },
    { icon: faVideo,         text: 'Online or phone meeting' },
    { icon: faCalendarCheck, text: 'Pick any slot that suits you' },
    { icon: faEnvelope,      text: 'Confirmation sent to your email' },
];

export default function ScheduleMeeting() {
    return (
        <div className="sched-page">

            {/* Hero */}
            <div className="sched-hero">
                <div className="sched-hero-overlay" />
                <div className="sched-hero-content">
                    <span className="sched-badge">Free Consultation</span>
                    <h1>Schedule a Meeting</h1>
                    <p>Pick a time that works for you and let's talk about your project.</p>

                    <div className="sched-perks">
                        {PERKS.map(({ icon, text }) => (
                            <div key={text} className="sched-perk">
                                <FontAwesomeIcon icon={icon} />
                                <span>{text}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Embedded Google Calendar */}
            <div className="sched-embed-wrap">
                <iframe
                    loading="lazy"
                    src={CALENDAR_URL}
                    title="Schedule a meeting with Surya Group"
                    className="sched-iframe"
                    frameBorder="0"
                    allowFullScreen
                />
            </div>

        </div>
    );
}
